import { createContext } from 'react'

export type PageHeaderContainers = {
	main: HTMLElement | null
	tabs: HTMLElement | null
	setHasTabs: (hasTabs: boolean) => void
}

export const PageHeaderContext = createContext<PageHeaderContainers | null>(null)
